module.exports = __webpack_public_path__ + "static/media/AR.48d89a56.png";